import { render, staticRenderFns } from "./SeeWork.vue?vue&type=template&id=874a54b4"
import script from "./SeeWork.vue?vue&type=script&lang=js"
export * from "./SeeWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports